var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"number-grow-warp"},[_c('span',{ref:"numberGrow",staticClass:"number-grow",attrs:{"data-time":_vm.time,"data-value":_vm.value}},[_vm._v("0")])])}
var staticRenderFns = []

export { render, staticRenderFns }